<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div>
        <a-range-picker
          v-model="dateRange"
          :allowClear="false"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          style="width:200px"
          v-tooltip="$t('writeOff.stockInDate')"
          @change="fetchData()"
        />
      </div>
      <div class=" ts-flex ts-space-x-3">
        <select
          class="form-control"
          style="width:200px"
          v-model="status"
          @change="fetchData()"
        >
          <option :value="0">Pendding</option>
          <option :value="1">Confirmed</option>
        </select>
        <ts-input
          v-model="search"
          v-tooltip="$t('writeOff.search')"
          :placeholder="$t('search')"
          style="width: 250px;"
          class="inline-block"
        />
      </div>
    </div>
    <div class="overflow-auto ts-mt-3">
      <Table
        :data="resources" 
				:columns="columns" 
				size="small"
				highlight-row
        stripe
				max-height="700"
        :loading="loading"
      >
          <template slot-scope="{ row }" slot="branchName">
            {{ row.branch.branch_name_en }}
          </template>
          <template slot-scope="{ row }" slot="stockInNumber">
            {{
              row.ref_stock_in ? row.ref_stock_in.stock_in_number : null
            }}
          </template>
          <template slot-scope="{ row }" slot="locationName">
            {{ row.location.location_name_en }}
          </template>
          <template slot-scope="{ row }" slot="isConfirm">
            <span class="badge badge-primary" v-if="row.is_confirm"
              >Confirmed</span
            >
            <span class="badge badge-info" v-else>Pendding</span>
          </template>
          <template slot-scope="{ row }" slot="confirmedBy">
            {{
              row.confirmed_by
                ? row.confirmed_by.employee
                  ? row.confirmed_by.employee.employee_name_en
                  : ''
                : ''
            }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="$t('view')"
              class="text-primary"
              @click.prevent="onView(row)"
            >
              <i class="fas fa-eye"></i>
            </a>
          </template>
      </Table>
    </div>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData">
      </ts-pagination>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'writeOffList',
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.$store.state.stock.writeOffConfirm.dateRange = [
      moment()
        .startOf('M')
        .format('DD-MM-YYYY'),
      moment()
        .endOf('M')
        .format('DD-MM-YYYY')
    ]
    this.fetchData()
  },
  computed: {
    ...mapState('stock/writeOffConfirm', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stock.writeOffConfirm.search
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_SEARCH', newValue)
        this.$store.commit('stock/writeOffConfirm/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get () {
        return this.$store.state.stock.writeOffConfirm.is_confirm
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_STATUS', newValue)
      }
    },
    dateRange: {
      get () {
        return this.$store.state.stock.writeOffConfirm.dateRange
      },
      set (newValue) {
        this.$store.commit('stock/writeOffConfirm/SET_DATE_RANGE', newValue)
      }
    },
    columns () {
      return [
        { 
          title: this.$t('writeOff.branch'),
          width: 120,
          slot: 'branchName' 
        },
        {
          title: this.$t('writeOff.date'),
          key: 'write_off_date',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('writeOff.writeOffNumber'),
          key: 'write_off_number',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('writeOff.referenceStockIn'),
          slot: 'stockInNumber',
          width: 260,
          align: 'center'
        },
        { 
          title: this.$t('writeOff.reason'),
          minWidth: 370,
          key: 'write_off_reason' 
        },
        { 
          title: this.$t('writeOff.warehouse'),
          minWidth: 120,
          slot: 'locationName'
        },
        {
          title: this.$t('writeOff.status'),
          slot: 'isConfirm',
          minWidth: 120,
          align: 'center'
        },
        {
          title: this.$t('writeOff.confirmedBy'),
          width: 130,
          slot: 'confirmedBy'
          
        },
        {
          title: this.$t('writeOff.confirmedDate'),
          key: 'confirmed_date',
          width: 150,
          align: 'center',
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 94
				}
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/writeOffConfirm/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onView (record) {
      this.$store.commit('stock/writeOffConfirm/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-confirm-write-off',
        params: { id: record.write_off_id }
      })
    },
    branchFilter (value) {
      this.$store.commit('stock/writeOffConfirm/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  }
}
</script>
